import {curry} from 'ramda';
import {SortingOptionsValues} from '@pluto/table/tableTypes';
import {Sort} from '@pluto/table';

export const getNewSort = (sort: Sort) => {
    switch(sort.sortOrder) {
    case SortingOptionsValues.desc:
        return {};
    
    case SortingOptionsValues.asc:
        return {
            sortBy: sort.sortBy,
            sortOrder: SortingOptionsValues.desc,
        };
    
    default:
        return {
            sortBy: sort.sortBy,
            sortOrder: SortingOptionsValues.asc,
        };
    }
};

export const handleSort = curry((componentParams, oldSort) => {
    const {
        setSort,
        setQCJobs,
        setQuery,
        history,
        params,
        route,
    } = componentParams;
    
    const newSort = getNewSort(oldSort);
    setSort(newSort);
    
    const newQuery = {
        ...params,
        sortBy: newSort.sortBy,
        sortOrder: newSort.sortOrder,
    };
    
    setQuery(history, route, newQuery);
    setQCJobs(newQuery);
});
